(function () {
  'use strict';

  function getFeaturedMediaIdForVariant(variantId, productData) {
    if (!productData || !productData.variants) return null;
    var v = productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (!v) return null;
    if (v.featured_media && v.featured_media.id) return v.featured_media.id;
    if (v.featured_image && v.featured_image.id) return v.featured_image.id;
    return null;
  }

  function showMediaById(productSection, mediaId) {
    if (!mediaId) return;

    var galleryEl = productSection.querySelector('media-gallery');
    if (!galleryEl) return;

    // Find the actual media element INSIDE the gallery (not in thumbnail variants elsewhere)
    var mediaItems = galleryEl.querySelectorAll('[data-media-id]');
    if (!mediaItems || mediaItems.length === 0) return;

    var targetItem = null;
    var targetMediaIdAttr = null;
    mediaItems.forEach(function (el) {
      if (targetItem) return;
      var dataMediaId = el.getAttribute('data-media-id') || '';
      // The Shopify media id is at the end after the last hyphen
      var idPart = dataMediaId.split('-').pop();
      if (idPart === String(mediaId)) {
        targetItem = el;
        targetMediaIdAttr = dataMediaId;
      }
    });

    // If this variant has no matching media in the gallery, do nothing.
    // This is the key guard: trying to setActiveMedia with an invalid id crashes the gallery.
    if (!targetItem || !targetMediaIdAttr) return;

    // Try setActiveMedia, but wrap in try/catch so any internal Dawn error doesn't break the gallery
    if (typeof galleryEl.setActiveMedia === 'function') {
      try {
        galleryEl.setActiveMedia(targetMediaIdAttr, true);
        return;
      } catch (err) {
        // Fall through to thumbnail click fallback
        if (window.console && console.warn) {
          console.warn('variant-image-switcher: setActiveMedia failed, falling back', err);
        }
      }
    }

    // Fallback 1: click the thumbnail
    var thumb = productSection.querySelector('[data-target="' + targetMediaIdAttr + '"]');
    if (thumb) {
      try { thumb.click(); return; } catch (err) {}
    }

    // Fallback 2: scroll the media item into view
    try {
      targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    } catch (err) {}
  }

  function getProductData(productSection) {
    var script = productSection.querySelector('[id^="ProductJson-"], [type="application/json"][data-product-json], script[id*="ProductJson"]');
    if (script) {
      try { return JSON.parse(script.textContent); } catch (e) {}
    }
    var formScript = productSection.querySelector('product-info script[type="application/json"]');
    if (formScript) {
      try { return JSON.parse(formScript.textContent); } catch (e) {}
    }
    return null;
  }

  function handleVariantChange(productSection) {
    try {
      var form = productSection.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      var variantId = idInput.value;
      if (!variantId) return;

      var productData = getProductData(productSection);
      var mediaId = getFeaturedMediaIdForVariant(variantId, productData);
      // If variant has no featured media, do nothing - leave current image as-is
      if (!mediaId) return;
      showMediaById(productSection, mediaId);
    } catch (err) {
      // Never let an error in image switching break the page
      if (window.console && console.warn) {
        console.warn('variant-image-switcher: handleVariantChange failed', err);
      }
    }
  }

  function attachListeners(productSection) {
    if (productSection.dataset.variantImageSwitcherAttached === '1') return;
    productSection.dataset.variantImageSwitcherAttached = '1';

    productSection.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var isSelect = t.tagName === 'SELECT' && (t.name === 'options[]' || t.closest('variant-selects, variant-radios'));
      var isRadio = t.type === 'radio' && t.closest('variant-selects, variant-radios');
      if (isSelect || isRadio) {
        setTimeout(function () { handleVariantChange(productSection); }, 60);
      }
    });

    var idInput = productSection.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      var lastVal = idInput.value;
      var observer = new MutationObserver(function () {
        if (idInput.value !== lastVal) {
          lastVal = idInput.value;
          handleVariantChange(productSection);
        }
      });
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  function init() {
    var productSections = document.querySelectorAll('[id^="MainProduct-"], section.product, .product-section, [data-section-type="product"]');
    productSections.forEach(attachListeners);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();